import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault, registerView } from "@frui.ts/views/dist";
import TerminatePreviewSectionView from "./deletePreviewSection";
import DeleteExemptionViewModel from "viewModels/callCenter/search/exemptions/deleteExemption/deleteExemptionViewModel";
import { formatLicensePlate } from "../../../../../utils/localizations";
import Icon, { IconType } from "@edaz/edazkit/Icon";

const DeleteExemptionView: ViewComponent<DeleteExemptionViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <Modal show={true} onHide={vm.onClose} centered size="lg">
      <Modal.Header className="d-flex flex-column justify-content-center align-items-center">
        <Icon className="mb-4 text-danger" icon={IconType.CircleWarning} width={72} height={72} />
        <Modal.Title>{`${vm.translate("name")} ${formatLicensePlate(vm.item.vehicle)}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          <Form onSubmit={preventDefault(vm.onDelete)}>
            <TerminatePreviewSectionView vm={vm} />
            <ButtonToolbar className="justify-content-center">
              <Button size="sm" type="reset" onClick={vm.onClose} variant="light">
                {vm.translateGeneral("cancel")}
              </Button>

              <Button size="sm" type="reset" variant="danger" onClick={vm.onDelete}>
                {vm.translateGeneral("delete")}
              </Button>
            </ButtonToolbar>
          </Form>
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(DeleteExemptionView, DeleteExemptionViewModel);
